function fabricObjectExtend(shape) {
    shape.toObject = (function (toObject) {
        return function () {
            return fabric.util.object.extend(toObject.call(this), {
                uuid: this.uuid,
                timeStamp: this.timeStamp
            });
        };
    })(shape.toObject);
}

function setActiveShapeStyle(shape) {
    shape.cornerColor = 'black';
    shape.transparentCorners = false;
    shape.cornerSize = 12;
}

export {
    fabricObjectExtend,
    setActiveShapeStyle
};